import { PlayIcon } from '@heroicons/react/24/solid'
import React, { useEffect, useState } from 'react'
import { useWindowDimensions } from '../../../Utils/useScreenSize'
import { ModalWithMediasProps } from './ModalWithMedia'
import { YoutubeVideo } from './YoutubeVideo'
import { fetchYouTubeVideoThumbnail } from './utils'

interface MediaProps extends ModalWithMediasProps {
  isIFrame?: boolean
}

export const Media = ({
  media,
  name,
  video,
  youTubeApiKey,
  isIFrame = false,
  // forceHeight = false,
}: MediaProps) => {
  if (!media) {
    console.warn(`No media provided for ${name}`)
    return null
  }
  const [thumbnail, setThumbnail] = useState<string | null>(null)
  const [isLoaded, setIsLoaded] = useState(false)
  const {
    dimensions: { width: windowWidth },
    setDimensions,
  } = useWindowDimensions({})

  useEffect(() => {
    const fetchThumbnail = async () => {
      if (video) {
        const url = await fetchYouTubeVideoThumbnail(media, (youTubeApiKey || process.env.YOUTUBE_API_KEY || null))
        setThumbnail(url)
      }
    }
    fetchThumbnail()
    setDimensions({ width: window.innerWidth, height: window.innerHeight })
    setIsLoaded(true)
  }, [media, video])

  if (video) {
    if (isIFrame) {
      const url = media
      return (
        <>
          <div id="video-container" className="hidden w-full h-full xl:block">
            <YoutubeVideo
              title={`vidéo de ${name}`}
              url={url as unknown as string}
              height={700}
              width={1024}
            />
          </div>
          <div
            id="video-container"
            className="hidden w-full h-full lg:block xl:hidden"
          >
            <YoutubeVideo
              title={`vidéo de ${name}`}
              url={url as unknown as string}
              height={700}
              width={824}
            />
          </div>
          <div
            id="video-container"
            className="hidden w-full h-full md:block lg:hidden"
          >
            <YoutubeVideo
              title={`vidéo de ${name}`}
              url={url as unknown as string}
              height={500}
              width={750}
            />
          </div>
          <div id="video-container" className="w-full h-full md:hidden">
            <YoutubeVideo
              title={`vidéo de ${name}`}
              url={url as unknown as string}
              height={250}
              width={windowWidth - 15}
            />
          </div>
        </>
      )
    }

    return (
      <div className="relative">
        <img
          src={thumbnail ?? media}
          alt={`vidéo de ${name}`}
          className="object-cover w-full h-full rounded-xl"
        />

        {isLoaded && (
          <div className="flex absolute inset-0 justify-center items-center">
            <PlayIcon className="w-12 h-12 text-white" />
          </div>
        )}
      </div>
    )
  }

  return (
    <img
      src={media}
      alt={`média de ${name}`}
      className="object-cover w-full h-full rounded-xl no-scrollbar"
    />
  )
}
